import jwt from 'jsonwebtoken';
import {genericGetWithParameters,genericDeleteWithParameters, genericCallWithBody, genericGetWithParametersNoEncrypted, decrypt} from './Networking';

const apiURL = window.REACT_APP_API_URL;
const apiKey = window.REACT_APP_API_KEY;

export async function getCountryById(id){
    try {
        let params = {
            'countryId': id,
        }
        let response = await genericGetWithParameters('Country/GetCountryById',params);
        return response;
    } catch (error) {
        console.error(error);
    }
}

export async function searchCountries(country){
    try {
        let sessionID = await localStorage.getItem('SessionID');
        let params = {
            'country': country
        }

        let query = Object.keys(params)
            .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
            .join('&');
        
        let response = await fetch(apiURL + 'Country/GetCountryName?' + query, {
            method: 'GET',
            headers: {
                SessionID: sessionID,
                'APIKey': apiKey,
            }
        });
        var helper = [];
        let responseJWT = await response.json();
        let responseFinal = await decrypt(responseJWT);

        for (var i = 0; i < responseFinal.totalCount; i++){
            helper.push({CountryId: responseFinal.countries[i].CountryId, CountryIdName: responseFinal.countries[i].CountryIdName});
        }
        if(responseFinal.totalCount > 0){
            return responseFinal.countries;
        } else {
            return [];
        }         
    } catch (error) {
        console.error(error);
    }
}

export async function getCountries(page, items){
    try {
        let sessionID = await localStorage.getItem('SessionID');
        let params = {
            'Page': page,
            'Items': items
        }

        let response = await genericGetWithParameters('Country/Get', params)
        return response;
    } catch (error) {
        console.error(error);
    }
}

export async function addCountry(objCountry) {
    try {
        let sessionID = await localStorage.getItem('SessionID');

        let response = await fetch(apiURL + 'Country/Post',{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'APIKey': apiKey,                
                SessionID: sessionID
            },
            body: JSON.stringify(objCountry),
        });
        if(response.status === 200){
            let responseJSON = await response.json();
            console.log(responseJSON);
            responseJSON.status = 200;
            return responseJSON;
        }else{
            return response;
        }
    } catch (error) {
        console.error(error);
    }
}

export async function saveCountry(model){

    try{
        let response = await genericCallWithBody('POST','Country/SaveCountry',model);
        return response;
    } catch (error) {
        console.error(error);
    }
}

//Country/Delete
export async function deleteCountry(putCountry) {
    try{
        let params = {
            'countryId': putCountry
        };
        let response = await genericDeleteWithParameters('Country/Delete',params);
        return response;
    } catch (error) {
        console.error(error);
    }
}
export async function getProductsByCountry(countryID){
    try {
        let params = { countryID }

        let response = await genericGetWithParameters('Country/GetProductsByCountry', params)
        return response;
    } catch (error) {
        console.error(error);
    }
}

export async function saveProductsByCountry(model){
    try{
        let response = await genericCallWithBody('POST','Country/SaveProductsByCountry',model);
        return response;
    } catch (error) {
        console.error(error);
    }
}

export async function getBankingStandardsByCountry(countryID, currencyID){    
    try{
        let params = {
            'countryID':countryID, 
            'currencyID':currencyID
        }
        let response = await genericGetWithParameters('Country/GetBankingStandardsByCountry', params);
        return response;
    } catch (error) {
        console.error(error);
    }
}

export async function saveBankingStandards(model){
    try{
        let response = await genericCallWithBody('POST','Country/SaveBankingStandards',model);
        return response;
    } catch (error) {
        console.error(error);
    }
}

export async function deleteBankingStandards(id) {
    try{
        let params = {
            'id': id
        };
        let response = await genericDeleteWithParameters('Country/DeleteBankingStandards',params);
        return response;
    } catch (error) {
        console.error(error);
    }
}

export async function getValidations(){    
    try{
        let params = {}
        let response = await genericGetWithParameters('Country/GetValidations', params);
        return response;
    } catch (error) {
        console.error(error);
    }
}

export async function saveValidation(model){
    try{
        let response = await genericCallWithBody('POST','Country/SaveValidation',model);
        return response;
    } catch (error) {
        console.error(error);
    }
}

export async function deleteValidation(id) {
    try{
        let params = {
            'id': id
        };
        let response = await genericDeleteWithParameters('Country/DeleteValidation',params);
        return response;
    } catch (error) {
        console.error(error);
    }
}

export async function needsIban(countryId){
    try {
        let params = {
            CountryId: countryId
        }
        let response = await genericGetWithParametersNoEncrypted('Country/NeedsIban',params);
        return response;
    } catch (error) {
        console.error(error);
    }
}

export async function GetListRestrictedCountries(customerID){
    try {
        let sessionID = await localStorage.getItem('SessionID');
        let params = {
            'customerID': customerID,
        }

        let response = await genericGetWithParameters('Country/GetListRestrictedCountries', params)
        return response;
    } catch (error) {
        console.error(error);
    }
}